module.exports = __webpack_public_path__ + "img/img15.fc86b8ef.png";